import React, {
  useState,
  createContext,
  useCallback,
  useEffect,
  useRef,
} from 'react';

import { fetchTranslations } from '../utils/fetchTranslation';

interface LanguageContextTypes {
  language: string;
  strings: { [key: string]: string };
  updateLanguage: Function;
  getTranslation: Function;
}

export const LanguageContext = createContext({} as LanguageContextTypes);

export const LanguageProvider: React.FC = ({ children }) => {
  // creating inital state and defaulting langugage to en
  const [{ language, strings }, setLanguage] = useState({
    language: 'en',
    strings: {},
  });

  const initialStringsLoaded = useRef(false);
  /**
   * @param newLang Currently can be 'en' or 'zh' - may add more as needed
   * needs to be same name as config file
   * @fetchTranslation gets all key:value objects from config files
   */

  const updateLanguage = useCallback(
    async (newLang) => {
      // checking to
      if (initialStringsLoaded.current && newLang === language) return;

      const newStrings = await fetchTranslations({ language: newLang });
      initialStringsLoaded.current = true;
      // Update state with new values
      setLanguage({
        language: newLang,
        strings: newStrings,
      });
    },
    [language]
  );

  useEffect(() => {
    updateLanguage(language);
  }, [language, updateLanguage]);

  /**
   *
   * @param key phrase you want from json translate value
   * @returns the static text from that key
   */
  const getTranslation = (key: string) => {
    return (strings as { [key: string]: string })[key];
  };

  const context = {
    language,
    strings,
    updateLanguage: updateLanguage,
    getTranslation: getTranslation,
  };
  //  rendered in index.tsx
  return (
    <LanguageContext.Provider value={context}>
      {children}
    </LanguageContext.Provider>
  );
};
